// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1GNaX","actionsCol":"EnrolledClinics_actionsCol__1mJhA"};